// extracted by mini-css-extract-plugin
export default {"image":"AllPartenairesItem_image__f0I8c","col_slide":"AllPartenairesItem_col_slide__VRPjV"};